/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import Card from "@mui/material/Card";

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import CustomText from "components/customtext/customtext";
import Height from "components/height/height";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  assignJobToDriverByID,
  getDriverByID,
  getDropLocation,
  getOrderByID,
  reAssignDriverByID,
} from "utils/api";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import "./ViewOrder.scss";
let LOGIN_DETAILS;

function AssignDriver() {
  const screenName = "Assign Driver";
  const { id } = useParams();
  const [driver, setDriver] = useState([]);
  const [addressWarehouse, setAddresswarehouse] = useState("");

  const [drop, setDrop] = useState([]);
  const [atFlag, SetATFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [routeLink, setRouteLink] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    orderNumber: "",
    orderDate: "",
    shipmentType: "",
    paymentType: "",
    senderCity: "",
    receiverCity: "",
    distance: "",
    totalCharges: "",
    notes: "",
    dropWarehouseID: "",
    startWarehouseID: "",
    businessUserID: "",
    orderStatus: "",
    assignedDriverID: "",
  });

  const [valuesLog, setValuesLog] = React.useState({
    assignedDriverID: "",
    jobStatus: "",
    jobStatusNotes: "",
  });

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleChangeLog = (name) => (event) => {
    setValuesLog({ ...valuesLog, [name]: event.target.value });
  };

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  values.businessUserID = LOGIN_DETAILS.businessUserID;

  useEffect(() => {
    if (id !== undefined) {
      fetchOrder();
      fetchDriver();
      fetchDropLocation();
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("ROUTE_TYPE") === "customer") {
      setRouteLink("/customerOrders");
    } else {
      setRouteLink("/orders");
    }
    sessionStorage.removeItem("ROUTE_TYPE");
  }, []);

  useEffect(() => {
    drop.map((val, i) => {
      if (
        values.startWarehouseID !== "" &&
        values.startWarehouseID !== undefined &&
        drop.length > 0
      )
        if (val._id === values.startWarehouseID) {
          setAddresswarehouse(val.warehouseName + ", " + val.streetAddress);
        }
    });
  }, [drop]);

  // -----sudhanshu need to review the issue
  const fetchOrder = async () => {
    getOrderByID(
      { id: id },
      (data) => {
        setValues(data.Result_Output[0]);
        if (
          data.Result_Output[0].startWarehouseID !== "" &&
          data.Result_Output[0].startWarehouseID !== undefined
        ) {
          setValues((prevValues) => ({
            ...prevValues,
            dropWarehouseID: data.Result_Output[0].startWarehouseID,
          }));
        }
      },
      dispatch
    );
  };

  const fetchDriver = async () => {
    getDriverByID(
      values,
      (data) => {
        setDriver(data.Result_Output);
      },
      dispatch
    );
  };

  const fetchDropLocation = async () => {
    getDropLocation(
      values,
      (data) => {
        setDrop(data.Result_Output);
      },
      dispatch
    );
  };

  const addAssigh = () => {
    if (
      values.assignedDriverID === undefined ||
      values.assignedDriverID.toString().trim() === ""
    ) {
      showResMsg("Please Select Driver First!", 1000, false);
      return;
    }

    if (values.orderStatus === "New") {
      values.orderID = id;
      assignJobToDriverByID(
        values,
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.updated : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            routeLink
          );
        },
        dispatch
      );
    } else {
      values.orderID = id;
      reAssignDriverByID(
        {
          orderID: values.orderID,
          assignedDriverID: values.assignedDriverID,
          dropWarehouseID: values.dropWarehouseID,
          notes: values.notes,
        },
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.updated : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            routeLink
          );
        },
        dispatch
      );
    }
  };

  let driverList =
    driver.length > 0 &&
    driver.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.firstName} {item.lastName}
        </MenuItem>
      );
    }, this);

  let dropList =
    drop.length > 0 &&
    drop.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.warehouseName}, {item.streetAddress}, {item.city}
        </MenuItem>
      );
    }, this);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container px={2}>
          {/* <Grid item xs={12} md={3} lg={12} sx={{ display: "flex", justifyContent: "end" }}>
            <Link to={"/orders"} >
              <MDButton color="warning">Back</MDButton>
            </Link>
          </Grid> */}
        </Grid>
        <Grid
          container
          px={2}
          mt={4}
          columnSpacing={2}
          justifyContent={"space-between"}
        >
          <Grid item xs={4.5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pt={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Order Number:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pt={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.orderNumber}
                  </CustomText>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pb={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Order Date:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pb={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.orderDate}
                  </CustomText>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={4.5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pt={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Consignment Type:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pt={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.shipmentType}{" "}
                  </CustomText>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pb={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Payment Type:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pb={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.paymentType}
                  </CustomText>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          px={2}
          mt={4}
          columnSpacing={2}
          justifyContent={"space-between"}
        >
          <Grid item xs={4.5} pl={5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid
                item
                xs={8}
                pl={5}
                style={{ display: "flex", alignItems: "center" }}
                pt={3}
              >
                <CustomText type="b" size={17} style={{ color: "black" }}>
                  Sender Address:
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderName}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderStreetAddress}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderCity} , {values.senderZipCode}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText
                  type="p"
                  size={17}
                  style={{ color: "black" }}
                ></CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderContactNumber}
                </CustomText>
              </Grid>

              <Height val={28} />
            </Card>
          </Grid>

          <Grid item xs={4.5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid
                item
                xs={8}
                pl={5}
                pt={3}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="b" size={17} style={{ color: "black" }}>
                  Receiver Address:
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.receiverName}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.receiverStreetAddress}
                  <br /> {values.receiverCity} , {values.receiverZipCode}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText
                  type="p"
                  size={17}
                  style={{ color: "black" }}
                ></CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.receiverContactNumber}
                </CustomText>
              </Grid>
              <Height val={28} />
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={3} px={2} py={4}>
          {atFlag && (
            <>
              <Grid item lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Last Assigned Driver
                  </InputLabel>

                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3em" }}
                    label="Last Assigned Driver"
                    disabled
                    value={valuesLog.assignedDriverID}
                    onChange={handleChangeLog("assignedDriverID")}
                  >
                    {driverList}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={4}>
                <FormControl fullWidth>
                  <TextField
                    type="text"
                    label="Driver Status"
                    variant="outlined"
                    fullWidth
                    disabled
                    value={valuesLog.jobStatus}
                    onChange={handleChangeLog("jobStatus")}
                  ></TextField>
                </FormControl>
              </Grid>
              <Grid item lg={4}>
                <FormControl fullWidth>
                  <TextField
                    type="text"
                    label="Driver Notes"
                    variant="outlined"
                    fullWidth
                    disabled
                    value={valuesLog.jobStatusNotes}
                    onChange={handleChangeLog("jobStatusNotes")}
                  ></TextField>
                </FormControl>
              </Grid>
            </>
          )}

          <Grid item lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Driver
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ minHeight: "3em" }}
                label="Select Driver"
                value={values.assignedDriverID}
                onChange={handleChange("assignedDriverID")}
              >
                {driverList}
                {/* <MenuItem value="South">South</MenuItem>
                        <MenuItem value="North">North</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField
              type="text"
              placeholder="Refer above Sender address"
              label="Pickup Address"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              fullWidth
              value={values.senderStreetAddress}
              readOnly
            />
          </Grid>
          {values.startWarehouseID !== "" &&
          values.startWarehouseID !== undefined ? (
            <>
              <Grid item xs={12} lg={4}>
                <TextField
                  type="text"
                  placeholder="Drop Address"
                  label="Drop Address"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "#000000",
                    },
                  }}
                  fullWidth
                  value={addressWarehouse}
                  readOnly
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Drop Address
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3em" }}
                    label="Drop Address"
                    value={values.dropWarehouseID}
                    onChange={handleChange("dropWarehouseID")}
                  >
                    {dropList}
                    {/* <MenuItem value="South">South</MenuItem>
                        <MenuItem value="North">North</MenuItem> */}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}

          <Grid item lg={12}>
            <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label">Drop Address</InputLabel> */}
              <TextField
                type="text"
                // placeholder="Notes"
                label="Notes"
                variant="outlined"
                fullWidth
                value={values.notes}
                onChange={handleChange("notes")}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Card>
      <Grid
        container
        mt={2}
        columnSpacing={4}
        alignItems="center"
        display="flex"
        justifyContent="center"
        mb={4}
      >
        <Grid item xs={12} md={4} spacing={2} lg={1.2}>
          <Link to={routeLink}>
            <MDButton
              className="btn-block center-container-btn btn-warning btn-back rightSpace"
              color="warning"
              fullWidth
            >
              Cancel
            </MDButton>
          </Link>
        </Grid>
        <Grid item xs={12} md={4} spacing={2} lg={1.2}>
          <MDButton
            rel="noreferrer"
            variant="gradient"
            color="success"
            fullWidth
            onClick={addAssigh}
          >
            Save
          </MDButton>
        </Grid>
      </Grid>
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default AssignDriver;
